<template>
  <div class="main-content-wrap sidenav-open d-flex flex-column pb-4">
    <div class="main-header pl-4 mt-3" style="z-index: 60;">
      <div class="row">
        <div
          style="align-self: center;"
          class="logo col-md-1 col-lg-1 col-12 py-0"
        >
          <div
            class="dropdown animate__animated animate__fadeIn"
            style="font-size: 120%;"
          >
            <i
              @click="hasHistory() ? $router.go(-1) : $router.push('/')"
              style="cursor: pointer; position: relative; top: 2px; color: #069;"
              class="fal fa-arrow-alt-circle-left mr-1"
            ></i>
            <span class="ml-2" style="top: 4%; position: relative;">Back</span>
          </div>
        </div>
      </div>
      <div style="margin: auto"></div>
    </div>

    <div
      class="main-content"
      :class="
        $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'
          ? 'px-2'
          : null
      "
    >
      <div
        class="breadcrumb d-flex justify-content-between align-items-center"
        style="margin-top: 1rem;"
      >
        <h1>
          <span class="col-4">Interviews</span>
        </h1>
        <div class="view-toggle">
          <v-btn-toggle v-model="viewMode" mandatory color="#069" dense>
            <v-btn value="calendar" small>
              <i class="fal fa-calendar-alt mr-1"></i>Calendar
            </v-btn>
            <v-btn value="list" small>
              <i class="fal fa-list mr-1"></i>List
            </v-btn>
          </v-btn-toggle>
        </div>
      </div>

      <!-- Calendar View -->
      <div v-if="viewMode === 'calendar' && !loading">
        <v-sheet height="600">
          <div
            class="calendar-nav d-flex align-items-center justify-content-between mb-2 px-2 py-1"
          >
            <div class="d-flex align-items-center">
              <v-btn
                small
                depressed
                color="#e9eef6"
                class="nav-btn"
                @click="prevCalendar"
                aria-label="Previous"
              >
                <i class="fal fa-chevron-left" style="color:#069"></i>
              </v-btn>
              <v-btn
                small
                depressed
                color="#069"
                class="nav-btn ml-2 text-white"
                @click="goToday"
                aria-label="Today"
              >
                Today
              </v-btn>
              <v-btn
                small
                depressed
                color="#e9eef6"
                class="nav-btn ml-2"
                @click="nextCalendar"
                aria-label="Next"
              >
                <i class="fal fa-chevron-right" style="color:#069"></i>
              </v-btn>
            </div>
            <div class="text-muted font-weight-600" style="font-size: 14px;">
              {{ calendarTitle }}
            </div>
          </div>
          <v-calendar
            v-if="calendarReady"
            ref="calendar"
            color="#069"
            :events="calendarEvents"
            event-overlap-mode="stack"
            type="month"
            :value="calendarFocus"
            @click:date="onDateClick"
          >
            <template v-slot:day="{ date }">
              <div v-if="dayCounts[date]" class="calendar-day-badge">
                {{ dayCounts[date] }}
              </div>
            </template>
          </v-calendar>
          <div v-else class="d-flex justify-center align-center" style="height: 600px;">
            <v-progress-circular indeterminate color="#069" size="40" />
          </div>
        </v-sheet>
      </div>

      <!-- List View -->
      <div v-else-if="viewMode === 'list'">
        <div class="card w-100" style="border-radius: 10px;">
          <div class="card-body px-1 py-1 pt-0 pr-0">
            <div class="px-3 pt-2">
              <div
                class="d-flex justify-content-between interviews-toolbar-row"
              >
                <div>
                  <strong>All Interviews</strong>
                  <v-btn
                    v-if="selectedCandidateIds.length > 0"
                    small
                    color="#069"
                    class="text-white ml-3"
                    @click="convertSelectedToCandidates"
                  >
                    Convert to Candidate(s) ({{ selectedCandidateIds.length }})
                  </v-btn>
                </div>
                <div class="interviews-toolbar d-flex align-items-center">
                  <v-text-field
                    v-model="search"
                    dense
                    solo
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    placeholder="Search"
                    style="max-width: 240px;"
                  />
                </div>
              </div>
            </div>

            <div
              class="table-responsive"
              style="border-radius: 10px; height: 600px; overflow-y: auto;"
            >
              <table class="table candidate-table">
                <thead>
                  <tr>
                    <th class="select-all-th" style="border-top: none;">
                      <label class="checkbox checkbox-secondary mb-0">
                        <input
                          type="checkbox"
                          :checked="
                            listViewRows.length &&
                            selectedCandidateIds.length ===
                              listViewRows.filter((r) => r.candidate_id).length
                          "
                          @change="toggleSelectAll"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </th>
                    <th class="text-left" style="border-top: none;">Date</th>
                    <th class="text-left" style="border-top: none;">Name</th>
                    <th class="text-left" style="border-top: none;">Email</th>
                    <th class="text-left" style="border-top: none;">Status</th>
                    <th class="text-left" style="border-top: none;">Time</th>
                    <th class="text-left" style="border-top: none;">Type</th>
                    <th class="text-center" style="border-top: none;">
                      Details
                    </th>
                    <th class="text-center" style="border-top: none;">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in listViewRows"
                    :key="`${row.interview_id}-${row.candidate_id || row.id}`"
                  >
                    <th>
                      <label
                        v-if="row.candidate_id"
                        class="checkbox checkbox-secondary"
                      >
                        <input
                          type="checkbox"
                          :checked="
                            selectedCandidateIds.indexOf(row.candidate_id) !==
                            -1
                          "
                          @change="toggleCandidateSelection(row.candidate_id)"
                        />
                        <span class="checkmark"></span>
                      </label>
                      <span v-else></span>
                    </th>
                    <td class="text-left">{{ formatDate(row.interview_date) }}</td>
                    <td class="text-left">{{ row.name || '-' }}</td>
                    <td class="text-left">{{ row.email || '-' }}</td>
                    <td class="text-left text-capitalize">
                      {{ row.status || 'scheduled' }}
                    </td>
                    <td class="text-left">
                      {{ row.start_time }} - {{ row.end_time }}
                    </td>
                    <td class="text-left text-capitalize">
                      {{ row.interview_type }}
                    </td>
                    <td class="text-center">
                      <span
                        @click="openDetailsFromListRow(row)"
                        style="cursor: pointer; color: #069;"
                        >Details</span
                      >
                    </td>
                    <td class="text-center">
                      <i
                        class="fal fa-trash"
                        style="cursor: pointer; color: #a33;"
                        @click="confirmDeleteFromListRow(row)"
                      ></i>
                    </td>
                  </tr>
                  <tr v-if="!loading && listViewRows.length === 0">
                    <td colspan="9" class="text-center">
                      No interviews found
                    </td>
                  </tr>
                  <tr v-if="loading">
                    <td colspan="9" class="text-center">
                      <v-progress-circular
                        indeterminate
                        color="#069"
                        size="20"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="detailsDialog" max-width="700px">
      <v-card>
        <v-card-title class="text-left d-block">
          <span class="headline">Interview Details</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div class="mb-2">
              <strong>Date:</strong> {{ formatDate(currentInterview.interview_date) }}
            </div>
            <div class="mb-2">
              <strong>Time:</strong> {{ currentInterview.start_time }} -
              {{ currentInterview.end_time }}
            </div>
            <div class="mb-2">
              <strong>Type:</strong> {{ currentInterview.interview_type }}
            </div>
            <div class="mb-2" v-if="currentInterview.meeting_link">
              <strong>Meeting Link:</strong>
              <a :href="currentInterview.meeting_link" target="_blank">Open</a>
            </div>
            <div class="mb-2" v-if="currentInterview.address">
              <strong>Address:</strong> {{ currentInterview.address }}
            </div>
            <div class="mb-4" v-if="currentInterview.comments">
              <strong>Comments:</strong> {{ currentInterview.comments }}
            </div>

            <div>
              <strong>Candidates</strong>
              <div
                class="table-responsive"
                style="border-radius: 10px; max-height: 260px; overflow-y: auto;"
              >
                <table class="table">
                  <thead>
                    <tr>
                      <th class="text-left">Name</th>
                      <th class="text-left">Email</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Notes</th>
                      <th class="text-center">Update</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="cand in normalizedCurrentInterviewCandidates"
                      :key="cand.id"
                    >
                      <td class="text-left">
                        {{
                          cand.name ||
                            `${cand.firstname ||
                              cand.employee_fristname ||
                              cand.employee_firstname ||
                              cand.first_name ||
                              ''} ${cand.lastname ||
                              cand.employee_lastname ||
                              cand.last_name ||
                              ''}`.trim() ||
                            `#${cand.id}`
                        }}
                      </td>
                      <td class="text-left">
                        {{ cand.email || cand.employee_email || '-' }}
                      </td>
                      <td class="text-left text-capitalize">
                        {{ cand.status || 'scheduled' }}
                      </td>
                      <td class="text-left">{{ cand.notes || '-' }}</td>
                      <td class="text-center">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              small
                              text
                              color="#069"
                              v-bind="attrs"
                              v-on="on"
                              >Change</v-btn
                            >
                          </template>
                          <v-list>
                            <v-list-item
                              v-for="opt in statusOptions"
                              :key="opt"
                              @click="updateCandidateStatus(cand, opt)"
                            >
                              <v-list-item-title class="text-capitalize">{{
                                opt
                              }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                    <tr
                      v-if="
                        !currentInterview.candidates ||
                          currentInterview.candidates.length === 0
                      "
                    >
                      <td colspan="5" class="text-center">No candidates</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="detailsDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Reschedule Interview Modal -->
    <v-dialog v-model="rescheduleDialog" max-width="800px" persistent>
      <v-card>
        <v-card-title
          style="background: linear-gradient(45deg, #17a2b8, #138496); color: white; border-radius: 15px 15px 0 0;"
        >
          <span class="headline">
            <i class="fal fa-calendar-edit mr-2"></i>Reschedule Interview
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form @submit.prevent="submitReschedule">
              <div class="container-fluid">
                <v-row>
                  <v-col cols="12" sm="6" md="6" class="remove-hint">
                    <span style="color: #111d5e; font-weight: 600;"
                      >Interview Type
                      <i
                        class="fal fa-asterisk"
                        style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"
                      ></i>
                    </span>
                    <v-select
                      v-model="rescheduleForm.interview_type"
                      :items="['virtual', 'physical', 'online']"
                      placeholder="Select interview type"
                      solo
                      dense
                      class="mt-2"
                      @change="onRescheduleTypeChange"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="remove-hint">
                    <span style="color: #111d5e; font-weight: 600;"
                      >Interview Date
                      <i
                        class="fal fa-asterisk"
                        style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"
                      ></i>
                    </span>
                    <v-menu
                      ref="rescheduleDateMenu"
                      v-model="rescheduleDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="rescheduleForm.interview_date"
                          label="Select date"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          solo
                          dense
                          class="mt-2"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="rescheduleForm.interview_date"
                        :min="new Date().toISOString().split('T')[0]"
                        @change="rescheduleDateMenu = false"
                        no-title
                        scrollable
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="remove-hint">
                    <span style="color: #111d5e; font-weight: 600;"
                      >Start Time
                      <i
                        class="fal fa-asterisk"
                        style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"
                      ></i>
                    </span>
                    <v-text-field
                      v-model="rescheduleForm.start_time"
                      type="time"
                      placeholder="HH:MM"
                      solo
                      dense
                      class="mt-2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="remove-hint">
                    <span style="color: #111d5e; font-weight: 600;"
                      >End Time
                      <i
                        class="fal fa-asterisk"
                        style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"
                      ></i>
                    </span>
                    <v-text-field
                      v-model="rescheduleForm.end_time"
                      type="time"
                      placeholder="HH:MM"
                      solo
                      dense
                      class="mt-2"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    v-if="rescheduleForm.interview_type === 'virtual' || rescheduleForm.interview_type === 'online'"
                    cols="12"
                    class="remove-hint"
                  >
                    <span style="color: #111d5e; font-weight: 600;"
                      >Meeting Link
                      <i
                        class="fal fa-asterisk"
                        style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"
                      ></i>
                    </span>
                    <v-text-field
                      v-model="rescheduleForm.meeting_link"
                      placeholder="http://meet.google.com/"
                      solo
                      dense
                      class="mt-2"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    v-if="rescheduleForm.interview_type === 'physical'"
                    cols="12"
                    class="remove-hint"
                  >
                    <span style="color: #111d5e; font-weight: 600;"
                      >Address
                      <i
                        class="fal fa-asterisk"
                        style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"
                      ></i>
                    </span>
                    <v-text-field
                      v-model="rescheduleForm.address"
                      placeholder="Office address"
                      solo
                      dense
                      class="mt-2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="remove-hint">
                    <span style="color: #111d5e; font-weight: 600;">Comments</span>
                    <v-textarea
                      v-model="rescheduleForm.comments"
                      placeholder="Screening with experts"
                      solo
                      dense
                      rows="3"
                      class="mt-2"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </div>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            @click="rescheduleDialog = false"
            :disabled="rescheduleLoading"
          >
            Cancel
          </v-btn>
          <v-btn
            color="#069"
            class="text-white"
            @click="submitReschedule"
            :loading="rescheduleLoading"
            :disabled="rescheduleLoading"
          >
            Reschedule
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import { BASE_URL } from '@/main';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      selectedDate: null,
      search: '',
      interviews: [],
      calendarFocus: new Date().toISOString().split('T')[0],
      viewMode: 'calendar', // 'calendar' or 'list'
      selectedCandidateIds: [], // For list view candidate selection
      detailsDialog: false,
      currentInterview: {},
      statusOptions: ['scheduled', 'completed', 'rescheduled', 'cancelled'],
      debugEnabled: true,
      calendarReady: false, // Flag to control calendar initialization
      rescheduleDialog: false,
      rescheduleLoading: false,
      rescheduleForm: {
        interview_type: '',
        interview_date: null,
        start_time: '',
        end_time: '',
        meeting_link: '',
        address: '',
        comments: '',
        calendar_sync: 'google',
      },
      rescheduleInterviewId: null,
      rescheduleCandidateIds: [],
      rescheduleDateMenu: false,
    };
  },
  computed: {
    ...mapGetters(['authCompanyData', 'authCompanyCandidates']),
    calendarEvents() {
      // Return empty array if interviews not loaded yet to prevent crashes
      if (!Array.isArray(this.interviews)) {
        return [];
      }
      return this.interviews
        .filter((i) => i && i.interview_date) // Filter out invalid entries
        .map((i) => ({
          name: (i.job_title || 'Interview') + ' (' + (i.start_time || '') + ')',
          start: i.interview_date,
          end: i.interview_date,
          color: '#069',
          interviewId: i.id,
        }));
    },
    dayCounts() {
      const counts = {};
      this.interviews.forEach((i) => {
        if (i && i.interview_date) {
          counts[i.interview_date] = (counts[i.interview_date] || 0) + 1;
        }
      });
      return counts;
    },
    calendarTitle() {
      // Derive title from calendarFocus (our internal pointer)
      const base = this.calendarFocus
        ? new Date(this.calendarFocus)
        : new Date();
      return base.toLocaleDateString('en-US', {
        month: 'long',
        year: 'numeric',
      });
    },
    filteredInterviews() {
      let list = this.interviews;
      if (this.selectedDate) {
        list = list.filter((i) => i.interview_date === this.selectedDate);
      }
      if (this.search) {
        const q = this.search.toLowerCase();
        list = list.filter(
          (i) =>
            (i.job_title || '').toLowerCase().includes(q) ||
            (i.interview_type || '').toLowerCase().includes(q) ||
            (i.stage_name || '').toLowerCase().includes(q)
        );
      }
      return list;
    },
    listViewRows() {
      // Flatten interviews with candidates for list view
      // Each row represents one candidate in an interview
      let rows = [];
      this.interviews.forEach((intr) => {
        const candidates = intr.candidates || [];
        // Use interview_date field (confirmed from logging)
        const interviewDate = intr.interview_date;
        
        if (candidates.length > 0) {
          // If interview has candidates, create a row for each candidate
          candidates.forEach((c) => {
            const normalized = this.normalizeCandidate(c);
            rows.push({
              interview_id: intr.id,
              candidate_id: normalized.id || normalized.candidate_id,
              interview_date: interviewDate,
              start_time: intr.start_time,
              end_time: intr.end_time,
              interview_type: intr.interview_type,
              name: normalized.name || '-',
              email: normalized.email || '-',
              status: normalized.status || 'scheduled',
            });
          });
        } else {
          // If interview has no candidates, show the interview itself as a row
          rows.push({
            interview_id: intr.id,
            candidate_id: null,
            interview_date: interviewDate,
            start_time: intr.start_time,
            end_time: intr.end_time,
            interview_type: intr.interview_type,
            name: '-',
            email: '-',
            status: 'scheduled',
          });
        }
      });

      // Apply search filter
      if (this.search) {
        const q = this.search.toLowerCase();
        rows = rows.filter(
          (r) =>
            (r.name || '').toLowerCase().includes(q) ||
            (r.email || '').toLowerCase().includes(q) ||
            (r.status || '').toLowerCase().includes(q) ||
            (r.interview_type || '').toLowerCase().includes(q) ||
            (r.interview_date || '').toLowerCase().includes(q)
        );
      }

      return rows;
    },
    normalizedCurrentInterviewCandidates() {
      // Ensure candidates in currentInterview are always normalized
      if (!this.currentInterview || !this.currentInterview.candidates) {
        return [];
      }
      return this.currentInterview.candidates.map((c) =>
        this.normalizeCandidate(c)
      );
    },
  },
  methods: {
    ...mapActions(['fetch_candidates']),
    hasHistory() {
      return window.history.length > 2;
    },
    prevCalendar() {
      if (!this.$refs.calendar) return;
      const d = this.calendarFocus ? new Date(this.calendarFocus) : new Date();
      d.setDate(1);
      d.setMonth(d.getMonth() - 1);
      const newFocus = d.toISOString().split('T')[0];
      if (newFocus !== this.calendarFocus) {
        this.calendarFocus = newFocus;
      }
      this.$nextTick(() => {
        if (this.$refs.calendar && this.$refs.calendar.prev) {
          this.$refs.calendar.prev();
        }
      });
    },
    nextCalendar() {
      if (!this.$refs.calendar) return;
      const d = this.calendarFocus ? new Date(this.calendarFocus) : new Date();
      d.setDate(1);
      d.setMonth(d.getMonth() + 1);
      const newFocus = d.toISOString().split('T')[0];
      if (newFocus !== this.calendarFocus) {
        this.calendarFocus = newFocus;
      }
      this.$nextTick(() => {
        if (this.$refs.calendar && this.$refs.calendar.next) {
          this.$refs.calendar.next();
        }
      });
    },
    goToday() {
      if (!this.$refs.calendar) return;
      const today = new Date();
      const todayStr = today.toISOString().split('T')[0];
      this.selectedDate = todayStr;
      if (todayStr !== this.calendarFocus) {
        this.calendarFocus = todayStr;
      }
      this.$nextTick(() => {
        if (this.$refs.calendar && this.$refs.calendar.move) {
          this.$refs.calendar.move(this.calendarFocus);
        }
      });
    },
    onDateClick({ date }) {
      this.selectedDate = date;
    },
    formatDate(dateStr) {
      // Handle null, undefined, or empty strings
      if (!dateStr) {
        return 'Not scheduled';
      }
      
      // Convert to string and trim
      const dateString = String(dateStr).trim();
      
      // Handle invalid date strings
      if (
        dateString === '0000-00-00' ||
        dateString === 'null' ||
        dateString === 'undefined' ||
        dateString === '' ||
        dateString === 'Invalid Date'
      ) {
        return 'Not scheduled';
      }
      
      try {
        // Handle YYYY-MM-DD format directly (most common from APIs)
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
          const [year, month, day] = dateString.split('-');
          // Check if it's a valid date (not 0000-00-00)
          if (year === '0000' || month === '00' || day === '00') {
            return 'Not scheduled';
          }
          // Format as MM/DD/YYYY directly without creating Date object to avoid timezone issues
          return `${month}/${day}/${year}`;
        }
        
        // Handle dates with time component (YYYY-MM-DD HH:MM:SS or YYYY-MM-DDTHH:MM:SS)
        if (/^\d{4}-\d{2}-\d{2}[T\s]/.test(dateString)) {
          const datePart = dateString.split(/[T\s]/)[0];
          const [year, month, day] = datePart.split('-');
          if (year === '0000' || month === '00' || day === '00') {
            return 'Not scheduled';
          }
          return `${month}/${day}/${year}`;
        }
        
        // Try parsing as a general date
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
          // If parsing fails but it looks like a date string, return as-is
          if (/^\d{4}-\d{2}-\d{2}/.test(dateString)) {
            return dateString;
          }
          return 'Not scheduled';
        }
        
        // Format as MM/DD/YYYY
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        });
      } catch (e) {
        // If all else fails, return the original string if it looks like a date
        if (/^\d{4}-\d{2}-\d{2}/.test(dateString)) {
          return dateString;
        }
        return 'Not scheduled';
      }
    },
    toggleSelectAll() {
      const candidateRows = this.listViewRows.filter((r) => r.candidate_id);
      const allSelected =
        candidateRows.length &&
        this.selectedCandidateIds.length === candidateRows.length;

      if (allSelected) {
        this.selectedCandidateIds = [];
      } else {
        this.selectedCandidateIds = candidateRows.map((r) => r.candidate_id);
      }
    },
    toggleCandidateSelection(candidateId) {
      const idx = this.selectedCandidateIds.indexOf(candidateId);
      if (idx === -1) {
        this.selectedCandidateIds.push(candidateId);
      } else {
        this.selectedCandidateIds.splice(idx, 1);
      }
    },
    async convertSelectedToCandidates() {
      const _this = this;
      const Toast = _this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', _this.$swal.stopTimer);
          toast.addEventListener('mouseleave', _this.$swal.resumeTimer);
        },
      });

      if (this.selectedCandidateIds.length === 0) {
        Toast.fire({ icon: 'error', title: 'Select at least one candidate' });
        return;
      }

      // Get selected rows from listViewRows
      const selected = this.listViewRows.filter(
        (r) =>
          r.candidate_id &&
          this.selectedCandidateIds.includes(r.candidate_id)
      );

      // Build payload from selected candidates
      const applicants = selected.map((c) => ({
        id: c.candidate_id,
        company_id: this.authCompanyData?.id,
        company_unique_id: this.authCompanyData?.company_unique_id,
        employee_fristname: (c.name || '').split(' ')[0] || '',
        employee_lastname:
          (c.name || '')
            .split(' ')
            .slice(1)
            .join(' ') || '',
        employee_email: c.email,
        employee_phone1: '',
        city: '',
        employee_state: '',
        employee_nationality: '',
        employee_address: '',
        experience: '',
        Highest_qualification: '',
        employee_maritalstatus: '',
        employee_sex: '',
        employee_education: [],
        employee_workexperience: [],
      }));

      try {
        await axios.post(`${BASE_URL}createbulkcandidate`, { applicants });
        Toast.fire({ icon: 'success', title: 'Converted to candidate(s)' });
        this.selectedCandidateIds = [];
        await this.fetch_candidates();
        // Navigate to Onboarding candidate view
        this.$router.push({ name: 'Onboarding' });
      } catch (e) {
        Toast.fire({ icon: 'error', title: 'Conversion failed' });
      }
    },
    openDetailsFromListRow(row) {
      // Find the interview and open details
      const interview = this.interviews.find((i) => i.id === row.interview_id);
      if (interview) {
        this.openDetails(interview);
      }
    },
    confirmDeleteFromListRow(row) {
      // Find the interview and delete it
      const interview = this.interviews.find((i) => i.id === row.interview_id);
      if (interview) {
        this.confirmDelete(interview);
      }
    },
    async fetchInterviews() {
      this.loading = true;
      this.calendarReady = false; // Disable calendar during fetch
      try {
        const token = localStorage.getItem('userToken');
        const { data } = await axios.get(`${BASE_URL}interviews`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        let interviews = Array.isArray(data?.data) ? data.data : data || [];
        
        // Normalize candidates if they exist in the initial fetch
        interviews = interviews.map((i) => {
          if (i.candidates && Array.isArray(i.candidates)) {
            return {
              ...i,
              candidates: i.candidates.map((c) => this.normalizeCandidate(c)),
            };
          }
          return i;
        });
        this.interviews = interviews;
        if (this.debugEnabled) {
          console.log(
            '[RecruitmentInterviews] fetched interviews:',
            this.interviews.length
          );
        }
        await this.ensureInterviewCandidates();
        
        // Enable calendar after data is loaded and DOM is ready
        await this.$nextTick();
        setTimeout(() => {
          this.calendarReady = true;
        }, 100);
      } catch (e) {
        console.log('[RecruitmentInterviews] fetchInterviews error', e);
        this.calendarReady = false;
      } finally {
        this.loading = false;
      }
    },
    async ensureInterviewCandidates() {
      const token = localStorage.getItem('userToken');
      const missing = this.interviews.filter(
        (i) => !Array.isArray(i.candidates)
      );
      if (!missing.length) return;
      try {
        const results = await Promise.all(
          missing.map((i) =>
            axios
              .get(`${BASE_URL}interviews/${i.id}`, {
                headers: { Authorization: `Bearer ${token}` },
              })
              .then((r) => ({
                id: i.id,
                data: r?.data?.data || r?.data || {},
              }))
          )
        );
        const map = new Map(results.map((r) => [r.id, r.data]));
        this.interviews = this.interviews.map((i) => {
          const d = map.get(i.id);
          if (d && d.candidates && Array.isArray(d.candidates)) {
            return {
              ...i,
              candidates: d.candidates.map((c) => this.normalizeCandidate(c)),
            };
          }
          return i;
        });
        if (this.debugEnabled) {
          console.log(
            '[RecruitmentInterviews] populated candidates for',
            results.length,
            'interviews'
          );
        }
      } catch (err) {
        console.log(
          '[RecruitmentInterviews] ensureInterviewCandidates error',
          err
        );
      }
    },
    normalizeCandidate(cand) {
      // Normalize candidate data to handle different field name variations
      if (!cand) return cand;

      // If this is a relationship object (has candidate_id but no name/email),
      // look up the actual candidate from the candidates list
      let actualCandidate = cand;
      if (cand.candidate_id && !cand.name && !cand.email) {
        // Try to find the candidate from authCompanyCandidates
        const foundCandidate = this.authCompanyCandidates?.find(
          (c) => c.id === cand.candidate_id || c.id == cand.candidate_id
        );
        if (foundCandidate) {
          // Merge the relationship data with the actual candidate data
          actualCandidate = {
            ...foundCandidate,
            ...cand, // Relationship fields (status, notes, etc.) override candidate fields
            candidate_id: cand.candidate_id, // Preserve the relationship ID
          };
        } else {
          // Try to find from interviews data
          for (const interview of this.interviews) {
            const found = (interview.candidates || []).find(
              (c) => c.id === cand.candidate_id || c.id == cand.candidate_id
            );
            if (found && (found.name || found.email)) {
              actualCandidate = {
                ...found,
                ...cand,
                candidate_id: cand.candidate_id,
              };
              break;
            }
          }
        }
      }

      // Get first name from various possible fields
      const firstname =
        actualCandidate.firstname ||
        actualCandidate.employee_fristname ||
        actualCandidate.employee_firstname ||
        actualCandidate.first_name ||
        '';

      // Get last name from various possible fields
      const lastname =
        actualCandidate.lastname ||
        actualCandidate.employee_lastname ||
        actualCandidate.last_name ||
        '';

      // Construct full name
      const fullName = `${firstname} ${lastname}`.trim();

      // Get email from various possible fields
      const email =
        actualCandidate.email || actualCandidate.employee_email || '';

      return {
        ...actualCandidate,
        // Normalize name fields
        firstname: firstname,
        lastname: lastname,
        // Normalize email fields
        email: email,
        // Ensure name is constructed if not present
        name: actualCandidate.name || fullName || '',
      };
    },
    async openDetails(item) {
      try {
        if (!item || !item.id) {
          return;
        }
        const token = localStorage.getItem('userToken');
        const { data } = await axios.get(`${BASE_URL}interviews/${item.id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const interview = data?.data || data || item;

        // Normalize all candidates in the interview
        if (interview.candidates && Array.isArray(interview.candidates)) {
          interview.candidates = interview.candidates.map((c) =>
            this.normalizeCandidate(c)
          );
        }
        this.currentInterview = interview;
        this.detailsDialog = true;
      } catch (e) {
        const interview = item;
        // Normalize candidates even from fallback data
        if (interview.candidates && Array.isArray(interview.candidates)) {
          interview.candidates = interview.candidates.map((c) =>
            this.normalizeCandidate(c)
          );
        }
        this.currentInterview = interview;
        this.detailsDialog = true;
      }
    },
    confirmDelete(item) {
      const _this = this;
      const Toast = _this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', _this.$swal.stopTimer);
          toast.addEventListener('mouseleave', _this.$swal.resumeTimer);
        },
      });
      _this.$swal
        .fire({
          title: 'Delete this interview?',
          showCancelButton: true,
          confirmButtonText: `Yes, Delete`,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              const token = localStorage.getItem('userToken');
              await axios.delete(`${BASE_URL}interviews/${item.id}`, {
                headers: { Authorization: `Bearer ${token}` },
              });
              Toast.fire({ icon: 'success', title: 'Interview deleted' });
              this.fetchInterviews();
            } catch (e) {
              Toast.fire({
                icon: 'error',
                title: 'Could not delete interview',
              });
            }
          }
        });
    },
    async updateCandidateStatus(candidate, status) {
      // If status is 'rescheduled', open reschedule modal instead
      if (status === 'rescheduled') {
        this.openRescheduleModal(candidate);
        return;
      }

      const _this = this;
      const Toast = _this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', _this.$swal.stopTimer);
          toast.addEventListener('mouseleave', _this.$swal.resumeTimer);
        },
      });
      try {
        const token = localStorage.getItem('userToken');
        await axios.patch(
          `${BASE_URL}interviews/candidates/${candidate.id}/status`,
          {
            status,
            notes: candidate.notes || null,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        Toast.fire({ icon: 'success', title: 'Status updated' });
        if (this.currentInterview?.id) {
          const {
            data,
          } = await axios.get(
            `${BASE_URL}interviews/${this.currentInterview.id}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          this.currentInterview = data?.data || data || this.currentInterview;
        }
        // Refresh interviews list
        await this.fetchInterviews();
      } catch (e) {
        Toast.fire({ icon: 'error', title: 'Could not update status' });
      }
    },
    openRescheduleModal(candidate) {
      // Find the interview for this candidate
      const interview = this.interviews.find((i) => {
        return (
          i.candidates &&
          i.candidates.some((c) => c.id === candidate.id || c.candidate_id === candidate.id)
        );
      });

      if (!interview) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
        Toast.fire({ icon: 'error', title: 'Interview not found' });
        return;
      }

      // Get all candidate IDs from this interview
      const candidateIds = (interview.candidates || []).map((c) => c.id || c.candidate_id);

      // Convert date to YYYY-MM-DD format for date picker if needed
      let formattedDate = interview.interview_date || null;
      if (formattedDate) {
        // If date is in DD-MM-YYYY format, convert to YYYY-MM-DD
        if (/^\d{2}-\d{2}-\d{4}$/.test(formattedDate)) {
          const [day, month, year] = formattedDate.split('-');
          formattedDate = `${year}-${month}-${day}`;
        }
        // If date is already in YYYY-MM-DD, use as is
        // If date is invalid or in wrong format, set to null
        if (!/^\d{4}-\d{2}-\d{2}$/.test(formattedDate)) {
          formattedDate = null;
        }
      }

      // Populate form with current interview data
      this.rescheduleForm = {
        interview_type: interview.interview_type || '',
        interview_date: formattedDate,
        start_time: interview.start_time || '',
        end_time: interview.end_time || '',
        meeting_link: interview.meeting_link || '',
        address: interview.address || '',
        comments: interview.comments || '',
        calendar_sync: 'google',
      };
      this.rescheduleInterviewId = interview.id;
      this.rescheduleCandidateIds = candidateIds;
      this.rescheduleDialog = true;
    },
    onRescheduleTypeChange() {
      // Clear meeting link or address when interview type changes
      if (this.rescheduleForm.interview_type === 'virtual' || this.rescheduleForm.interview_type === 'online') {
        this.rescheduleForm.address = '';
      } else if (this.rescheduleForm.interview_type === 'physical') {
        this.rescheduleForm.meeting_link = '';
      }
    },
    async submitReschedule() {
      const _this = this;
      const Toast = _this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', _this.$swal.stopTimer);
          toast.addEventListener('mouseleave', _this.$swal.resumeTimer);
        },
      });

      // Validation
      if (
        !this.rescheduleForm.interview_type ||
        !this.rescheduleForm.interview_date ||
        !this.rescheduleForm.start_time ||
        !this.rescheduleForm.end_time
      ) {
        Toast.fire({
          icon: 'error',
          title: 'Please fill all required fields',
        });
        return;
      }

      if (
        (this.rescheduleForm.interview_type === 'virtual' || this.rescheduleForm.interview_type === 'online') &&
        !this.rescheduleForm.meeting_link
      ) {
        Toast.fire({
          icon: 'error',
          title: 'Please provide meeting link for virtual interview',
        });
        return;
      }

      if (
        this.rescheduleForm.interview_type === 'physical' &&
        !this.rescheduleForm.address
      ) {
        Toast.fire({
          icon: 'error',
          title: 'Please provide address for physical interview',
        });
        return;
      }

      this.rescheduleLoading = true;

      try {
        const token = localStorage.getItem('userToken');
        
        // Format date - convert from YYYY-MM-DD to DD-MM-YYYY as per API spec
        const dateParts = this.rescheduleForm.interview_date.split('-');
        const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;

        // Get interview details to include job_id and stage_id
        const interview = this.interviews.find((i) => i.id === this.rescheduleInterviewId);
        
        const payload = {
          job_id: interview?.job_id || null,
          stage_id: interview?.stage_id || null,
          interview_type: this.rescheduleForm.interview_type,
          interview_date: formattedDate,
          start_time: this.rescheduleForm.start_time,
          end_time: this.rescheduleForm.end_time,
          meeting_link:
            this.rescheduleForm.interview_type === 'virtual' || this.rescheduleForm.interview_type === 'online'
              ? this.rescheduleForm.meeting_link
              : null,
          address:
            this.rescheduleForm.interview_type === 'physical'
              ? this.rescheduleForm.address
              : null,
          comments: this.rescheduleForm.comments || '',
          calendar_sync: this.rescheduleForm.calendar_sync || 'google',
          candidate_ids: this.rescheduleCandidateIds,
        };

        await axios.put(
          `${BASE_URL}interviews/${this.rescheduleInterviewId}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        Toast.fire({
          icon: 'success',
          title: 'Interview rescheduled successfully',
        });

        this.rescheduleDialog = false;
        this.resetRescheduleForm();
        await this.fetchInterviews();
        
        // Refresh current interview if dialog is open
        if (this.currentInterview?.id === this.rescheduleInterviewId) {
          await this.openDetails({ id: this.rescheduleInterviewId });
        }
      } catch (error) {
        const errorMsg =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          'Failed to reschedule interview';
        Toast.fire({
          icon: 'error',
          title: errorMsg,
        });
        console.error('Reschedule error:', error);
      } finally {
        this.rescheduleLoading = false;
      }
    },
    resetRescheduleForm() {
      this.rescheduleForm = {
        interview_type: '',
        interview_date: null,
        start_time: '',
        end_time: '',
        meeting_link: '',
        address: '',
        comments: '',
        calendar_sync: 'google',
      };
      this.rescheduleInterviewId = null;
      this.rescheduleCandidateIds = [];
    },
  },
  mounted() {
    document.title = 'Kylian ERP - Interviews';
    this.fetchInterviews();
  },
};
</script>

<style>
.interviews-toolbar-row {
  min-height: 48px;
  align-items: center;
  padding: 6px 0;
  flex-wrap: wrap;
}
.interviews-toolbar {
  gap: 10px;
}
.interviews-toolbar .v-input,
.interviews-toolbar .v-input__control {
  margin-bottom: 0 !important;
}
.candidate-table thead th {
  background: #0b5cab;
  color: #fff;
}
.candidate-table th,
.candidate-table td {
  vertical-align: middle;
}
.candidate-table th:first-child,
.candidate-table td:first-child {
  width: 56px;
  text-align: left;
}
/* TWEAK: Adjust the vertical offset of the header select-all checkbox here */
.select-all-th .checkbox {
  position: relative;
  top: -20px; /* <- move up/down if needed */
}
.candidate-table .checkbox {
  margin: 0;
}
.candidate-table .checkbox input {
  transform: scale(0.85);
}
.candidate-table .checkbox .checkmark {
  top: 0;
}
.view-toggle {
  margin-left: auto;
}
.view-toggle .v-btn-toggle {
  border-radius: 4px;
}
.calendar-nav {
  background: #fff;
  border: 1px solid #e5e9f2;
  border-radius: 8px;
}
.calendar-nav .nav-btn {
  min-width: 36px;
  height: 32px;
}
.calendar-day-badge {
  position: absolute;
  top: 4px;
  right: 6px;
  background: #069;
  color: #fff;
  border-radius: 999px;
  font-size: 10px;
  line-height: 16px;
  height: 16px;
  min-width: 16px;
  padding: 0 4px;
  text-align: center;
}
/* Ensure day cells can host absolute elements */
.v-calendar-monthly .v-calendar-monthly__day,
.v-calendar-weekly .v-calendar-weekly__day {
  position: relative;
}
</style>
